import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import CasinoIcon from "@mui/icons-material/Casino";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";

export const HeroSection = () => {
  return (
    <Box
      sx={{
        background:
          "linear-gradient(135deg, hsl(350, 80%, 40%) 0%, hsl(350, 85%, 30%) 100%)",
        color: "white",
        py: { xs: 8, md: 12 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          opacity: 0.1,
          backgroundImage:
            "radial-gradient(circle, white 1px, transparent 1px)",
          backgroundSize: "30px 30px",
        }}
      />
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h1"
            sx={{
              fontFamily: '"Mountains of Christmas", cursive',
              fontSize: { xs: "2.5rem", md: "4rem" },
              fontWeight: 700,
              mb: 2,
              textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            🎄 Χριστουγεννιάτικη Λοταρία 🎁
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 300,
              mb: 4,
              maxWidth: 600,
              mx: "auto",
              opacity: 0.95,
            }}
          >
            Δημιουργήστε μαγικές κληρώσεις για τις γιορτές σας. Προσθέστε
            έπαθλα, προσκαλέστε τους συμμετέχοντες και αφήστε τη γιορτινή
            διασκέδαση να ξεκινήσει!
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Button
              component={Link}
              to="/lotteries"
              variant="contained"
              size="large"
              startIcon={<CasinoIcon />}
              sx={{
                bgcolor: "white",
                color: "hsl(350, 80%, 40%)",
                fontWeight: 600,
                px: 4,
                py: 1.5,
                borderRadius: 3,
                "&:hover": {
                  bgcolor: "hsl(30, 50%, 96%)",
                  transform: "translateY(-2px)",
                },
                transition: "all 0.2s",
                boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
              }}
            >
              Δες τις Λοταριες
            </Button>
            <Button
              component={Link}
              to="/run"
              variant="outlined"
              size="large"
              startIcon={<PlayCircleIcon />}
              sx={{
                borderColor: "white",
                color: "white",
                fontWeight: 600,
                px: 4,
                py: 1.5,
                borderRadius: 3,
                borderWidth: 2,
                "&:hover": {
                  borderColor: "white",
                  borderWidth: 2,
                  bgcolor: "rgba(255,255,255,0.1)",
                  transform: "translateY(-2px)",
                },
                transition: "all 0.2s",
              }}
            >
              Κανε Κληρωση
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
